import React, { useState, useEffect, ChangeEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FormGroup,
  FormControl,
  TextField,
  Select,
  MenuItem,
  Button,
  InputAdornment,
  IconButton,
  Typography, // Import Typography component
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import userProfile from '../../../../assets/images/userProfile.svg';
import profileDelete from '../../../../assets/images/profileDeleteIcon.svg';
import { Popup } from '../../../../components/index';
import { useAlert } from '../../../../components/Notification';
import createAxiosInstance from '../../../../api';
import { hashPassword } from '../../../../constant/constant';
import { useSelector } from 'react-redux';
import { useHook as DealerHook } from '../../profileManagement/useHook';
import CropComponent from '../../../../components/crop';

const EditProfile = () => {
  const userRole = localStorage.getItem('role');
  const { dealerInformation } = useSelector((state: any) => state.auth);
  const { fetchDealerInfo } = DealerHook();
  const navigate = useNavigate();
  const showAlert = useAlert();
  const axiosInstance = createAxiosInstance();
  const [userFirstName, setUserFirstName] = useState('');
  const [countryCode, setCountryCode] = useState('+91');
  const [userLastName, setUserLastName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [dealerOrganization, setDealerOrganization] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [userNameError, setUserNameError] = useState('');
  const [uploadError, setUploadError] = useState('');
  const [mobileNumberError, setMobileNumberError] = useState('');
  const [orgNameError, setOrgNameError] = useState('');
  const [profileError, setProfileError] = useState('');
  const [currentPasswordError, setCurrentPasswordError] = useState('');
  const [newPasswordError, setNewPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [croppedImage, setCroppedImages] = useState<string | null>(null);
  const [opencrop, setOpenCrop] = useState(false);

  const fetchImage = async (imageUrl: RequestInfo | URL) => {
    if (imageUrl) {
      try {
        const response = await fetch(imageUrl);
        const blob = await response.blob();

        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result) {
            const base64String = reader.result.toString().split(',')[1]; // Extracting base64 string
            const imageString = `data:image/png;base64,${base64String}`;
            setCroppedImages(imageString); // Set the base64 string to state
          }
        };
        reader.readAsDataURL(blob);
      } catch (error) {
        console.error('Failed to fetch image:', error);
      }
    }
  };

  const handleCropComplete = (croppedImage: string) => {
    setCroppedImages(croppedImage);
    setOpenCrop(false);
    setUploadError('');
  };

  const handleDelete = () => {
    setDeletePopup(false);
  };
  const handleFileButtonClick = () => {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  };

  const validation = () => {
    let valid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (mobileNumber?.length > 0) {
      if (!phoneRegex.test(mobileNumber)) {
        setMobileNumberError('Invalid mobile number');
        valid = false;
      }
    }

    if (userRole === 'dealer' && dealerOrganization?.length <= 0) {
      setOrgNameError('Organization name is required');
      valid = false;
    }

    if (opencrop) {
      setUploadError('Please upload the image');
      valid = false;
    }

    if (
      userFirstName?.trim()?.length <= 0 &&
      userLastName?.trim()?.length <= 0
    ) {
      setUserNameError('User name is required');
      valid = false;
    }
    if (countryCode?.length <= 0 && mobileNumber?.length > 0) {
      setMobileNumberError('Country code is required');
      valid = false;
    }
    if (mobileNumber?.length === 0 || !mobileNumber) {
      setMobileNumberError(' mobile number  is required');
      valid = false;
    }
    return valid;
  };

  //getDealerDetails
  const getDealerDetails = async () => {
    await fetchDealerInfo().then((res: any) => {
      if (res && res?.errorCode == 401) {
        localStorage.clear();
        navigate('/dealerlogin');
      }
    });
  };

  const handlesubmit = () => {
    if (validation()) {
      const imageType = croppedImage?.substring(11, croppedImage?.indexOf(';'));
      const imageWithoutPrefix = croppedImage?.substring(
        croppedImage?.indexOf(',') + 1,
      );
      const payload = {
        firstName: userFirstName,
        lastName: userLastName,
        phoneNumber: mobileNumber,
        avatar: imageWithoutPrefix,
        ext: imageType,
      };

      if (userRole === 'dealer') {
        const dealerPayload = {
          dealerID: dealerInformation?.dealerID,
          firstName: userFirstName,
          lastName: userLastName,
          phoneNumber: mobileNumber,
          avatar: imageWithoutPrefix,
          ext: imageType,
          orgName: dealerOrganization,
        };

        axiosInstance
          .post('/dealers/updateDealerInfo', dealerPayload)
          .then(() => {
            showAlert(`Profile Update successfully`, 'success');
            getDealerDetails();
          })
          .catch(() => {
            showAlert(`Failed to Update Profile`, 'error');
          });
      } else {
        axiosInstance
          .post('/selfDetailsChange', payload)
          .then(() => {
            showAlert(`Profile Update successfully`, 'success');
          })
          .catch(() => {
            showAlert(`Failed to Update Profile`, 'error');
          });
      }
    }
  };
  const validateImage = (
    file: File,
    setProfileError: (error: string) => void,
  ): boolean => {
    const allowedTypes: string[] = ['image/jpeg', 'image/png', 'image/gif'];
    const maxFileSize: number = 1024 * 1024; // 1MB

    if (!allowedTypes.includes(file.type)) {
      setProfileError('Please select a JPG, GIF, or PNG file.');
      return false;
    }

    if (file.size > maxFileSize) {
      setProfileError('File size exceeds the 1MB limit.');
      return false;
    }

    return true;
  };

  const validationPassword = () => {
    let valid = true;

    if (currentPassword.length < 8) {
      currentPassword.length > 0
        ? setCurrentPasswordError('Password must be at least 8 characters')
        : setCurrentPasswordError('Current Password is required');
      valid = false;
    }

    if (newPassword.length < 8) {
      newPassword.length > 0
        ? setNewPasswordError('Password must be at least 8 characters')
        : setNewPasswordError('New Password is required');
      valid = false;
    }

    if (confirmPassword.length < 8) {
      confirmPassword.length > 0
        ? setConfirmPasswordError('Password must be at least 8 characters')
        : setConfirmPasswordError('Confirm Password is required');
      valid = false;
    } else if (newPassword !== confirmPassword) {
      setConfirmPasswordError('Passwords do not match');
      valid = false;
    }

    return valid;
  };

  const handleSubmitPassword = () => {
    if (validationPassword()) {
      const payload = {
        password: hashPassword(newPassword),
      };
      if (userRole === 'dealer') {
        axiosInstance
          .post('/dealers/selfPasswordChange', payload)
          .then(() => {
            showAlert('Password Update Successfully', 'success');
            restPasswordField();
          })
          .catch(() => {
            showAlert('Password Update Failed', 'error');
          });
      } else {
        axiosInstance
          .post('/selfPasswordChange', payload)
          .then(() => {
            showAlert('Password Update Successfully', 'success');
            restPasswordField();
          })
          .catch(() => {
            showAlert('Password Update Failed', 'error');
          });
      }
    }
  };

  const restPasswordField = () => {
    setConfirmPassword('');
    setNewPassword('');
    setCurrentPassword('');
  };

  const getuserdetails = async () => {
    if (userRole !== 'dealer') {
      return await axiosInstance
        .get('/user')
        .then(async (response) => {
          fetchImage(response?.data?.data?.avatar);
          setUserFirstName(response.data.data.firstName);
          setUserLastName(response.data.data.lastName);
          setUserEmail(response.data.data.email);
          setMobileNumber(response.data.data.phoneNumber);
        })
        .catch(() => {
          setUserFirstName('');
          setUserLastName('');
        });
    }
  };

  useEffect(() => {
    getuserdetails();
  }, []);

  useEffect(() => {
    if (userRole === 'dealer') {
      setUserFirstName(dealerInformation?.firstName);
      setUserLastName(dealerInformation?.lastName);
      setUserEmail(dealerInformation?.primaryEmail);
      setDealerOrganization(dealerInformation?.orgName);
      setMobileNumber(dealerInformation?.phoneNumber);
      fetchImage(dealerInformation?.avatar);
    }
  }, [dealerInformation]);

  const toBase64 = (file: Blob) =>
    new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result);
        } else {
          reject(new Error('Failed to read file as Data URL'));
        }
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  const handleFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
    const file: File | null = e.target.files ? e.target.files[0] : null;

    if (file && validateImage(file, setProfileError)) {
      setProfileError('');

      await toBase64(file)
        .then((base64String) => {
          setCroppedImages(base64String as string);
          setOpenCrop(true);
        })
        .catch(() => {
          setCroppedImages('');
          showAlert(`Failed to Upload Image.`, 'error');
          setOpenCrop(false);
        });
    }
  };

  const handleDeleteImage = () => {
    setCroppedImages('');
    const uploadInput = document.getElementById(
      'upload-button',
    ) as HTMLInputElement;
    if (uploadInput) {
      uploadInput.value = '';
    }
    setUploadError('');
  };

  return (
    <>
      {deletePopup && (
        <Popup
          open={deletePopup}
          handleClose={() => {
            setDeletePopup(false);
          }}
          handleDelete={() => {
            handleDelete();
          }}
          page="profile"
        />
      )}
      <div className="create_user_management">
        <FormControl className="w-100">
          <div className="row d-flex  w-100">
            <div className="col-md-6">
              <Typography variant="h6">
                <b>Name</b>
              </Typography>
              {/* <Typography variant="body1" className="create_user_formlabel">
                Will appear on profile and other communications
              </Typography> */}
            </div>
            <div className="col-md-6  p-0 ">
              <FormGroup>
                <div className="create_user_name">
                  <TextField
                    className="create_user_name_input"
                    id="userfirtname"
                    value={userFirstName}
                    onChange={(e) => {
                      setUserFirstName(e.target.value), setUserNameError('');
                    }}
                    variant="outlined"
                    error={userNameError ? true : false}
                  />
                  <TextField
                    className="create_user_name_input"
                    id="userlastname"
                    value={userLastName}
                    error={userNameError ? true : false}
                    onChange={(e) => {
                      setUserLastName(e.target.value), setUserNameError('');
                    }}
                    variant="outlined"
                  />
                </div>
              </FormGroup>
              {userNameError && (
                <Typography variant="body2" className="text-danger">
                  {userNameError}
                </Typography>
              )}
            </div>
          </div>
          <hr />
          <div className="row d-flex  w-100">
            <div className="col-md-6">
              <Typography variant="h6">
                <b>Profile Picture</b>
              </Typography>
            </div>
            <div className="col-md-6 p-0">
              <div className="create_user_profile-container">
                <div className="create_user_profile">
                  <div>
                    {croppedImage ? (
                      <img src={croppedImage} width={72} alt="User Profile" />
                    ) : (
                      <img src={userProfile} width={72} alt="User Profile" />
                    )}
                  </div>
                  <div>
                    <label
                      // variant="outlined"
                      // component="label"
                      htmlFor="upload-button"
                      className="custom-file-upload"
                    >
                      Change
                    </label>
                    <input
                      type="file"
                      accept="image/*"
                      id="upload-button"
                      onChange={(e) => handleFileChange(e)}
                    />
                  </div>
                  <div className="imageformat">
                    <p>JPG, GIF, or PNG. 1MB Max.</p>
                  </div>
                </div>
                {croppedImage && (
                  <Button
                    className="create_user_profile-delete"
                    onClick={() => handleDeleteImage()}
                  >
                    <img src={profileDelete} width={44} alt="delete icon" />
                  </Button>
                )}
              </div>
              {profileError && (
                <span className="text-danger">{profileError}</span>
              )}
              {opencrop && croppedImage && (
                <CropComponent
                  srce={croppedImage}
                  onCropComplete={handleCropComplete}
                  uploadError={uploadError}
                />
              )}
            </div>
          </div>
          <hr />
          <div className="row d-flex  w-100">
            <div className="col-md-6">
              <Typography variant="h6">
                <b>Contact Number</b>
              </Typography>
              {/* <Typography variant="body1" className="create_user_formlabel">
                Will appear on profile and other communications
              </Typography> */}
            </div>
            <div className="col-md-6  p-0 ">
              <FormGroup>
                <div className="create_user_name">
                  <Select
                    className="form-countrycode"
                    id="countrycode"
                    value="+91"
                    onChange={(e) => {
                      setCountryCode(e.target.value), setMobileNumberError('');
                    }}
                    error={mobileNumberError ? true : false}
                    variant="outlined"
                  >
                    <MenuItem value="+91">+91</MenuItem>
                  </Select>
                  <TextField
                    className="form-mobile"
                    id="mobile"
                    value={mobileNumber}
                    inputProps={{ maxLength: 10 }}
                    onChange={(e) => {
                      const sanitizedValue = e.target.value.replace(/\D/g, '');
                      setMobileNumber(sanitizedValue);
                      setMobileNumberError('');
                    }}
                    variant="outlined"
                    error={mobileNumberError ? true : false}
                  />
                </div>
              </FormGroup>
              {mobileNumberError && (
                <Typography variant="body2" className="text-danger">
                  {mobileNumberError}
                </Typography>
              )}
            </div>
          </div>
          <hr />
          <div className="row d-flex  w-100">
            <div className="col-md-6">
              <Typography variant="h6">
                <b>Email</b>
              </Typography>
              {/* <Typography variant="body1" className="create_user_formlabel">
                Enter your Email for reset password or forgot password
              </Typography> */}
            </div>
            <div className="col-md-6  p-0 ">
              <FormGroup>
                <TextField
                  id="useremail"
                  value={userEmail}
                  disabled
                  variant="outlined"
                  fullWidth
                />
              </FormGroup>
            </div>
          </div>

          {userRole === 'dealer' && (
            <>
              <hr />
              <div className="row d-flex  w-100">
                <div className="col-md-6">
                  <Typography variant="h6">
                    <b>Dealer Organization</b>
                  </Typography>
                </div>
                <div className="col-md-6  p-0 ">
                  <FormGroup>
                    <TextField
                      id="orgName"
                      value={dealerOrganization}
                      onChange={(e) => {
                        setDealerOrganization(e.target.value),
                          setOrgNameError('');
                      }}
                      variant="outlined"
                      error={orgNameError ? true : false}
                      fullWidth
                    />
                  </FormGroup>
                  {orgNameError && (
                    <Typography variant="body2" className="text-danger">
                      {orgNameError}
                    </Typography>
                  )}
                </div>
              </div>
            </>
          )}
        </FormControl>
        <hr />

        <div className="submit-btn d-flex justify-content-end">
          <Button color="primary" onClick={handlesubmit}>
            Save Changes
          </Button>
        </div>
      </div>
      <div className="create_user_management mt-5">
        <FormControl className="w-100">
          <div className="row d-flex  w-100">
            <div className="col-md-6">
              <Typography variant="h6">
                <b>Change Password</b>
              </Typography>
              {/* <Typography variant="body1" className="create_user_formlabel">
                Enter your Email for reset password or forgot password
              </Typography> */}
            </div>
            <div className="col-md-6  p-0 ">
              <FormGroup>
                <div className="edit_profile_password">
                  <TextField
                    fullWidth
                    variant="outlined"
                    type={showCurrentPassword ? 'text' : 'password'}
                    placeholder="Current Password"
                    autoComplete="new-password"
                    value={currentPassword}
                    onChange={(e) => {
                      setCurrentPassword(e.target.value);
                      setCurrentPasswordError('');
                    }}
                    error={currentPasswordError.length > 0}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() =>
                              setShowCurrentPassword(!showCurrentPassword)
                            }
                            onMouseDown={(e) => e.preventDefault()}
                            edge="end"
                          >
                            {showCurrentPassword ? (
                              <VisibilityOff className="iconStyle" />
                            ) : (
                              <Visibility className="iconStyle" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {currentPasswordError && (
                    <Typography variant="body2" className="text-danger">
                      {currentPasswordError}
                    </Typography>
                  )}
                </div>
                <div className="edit_profile_password">
                  <TextField
                    fullWidth
                    variant="outlined"
                    type={showNewPassword ? 'text' : 'password'}
                    placeholder="New Password"
                    autoComplete="off"
                    value={newPassword}
                    onChange={(e) => {
                      setNewPassword(e.target.value);
                      setNewPasswordError('');
                    }}
                    error={newPasswordError.length > 0}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowNewPassword(!showNewPassword)}
                            onMouseDown={(e) => e.preventDefault()}
                            edge="end"
                          >
                            {showNewPassword ? (
                              <VisibilityOff className="iconStyle" />
                            ) : (
                              <Visibility className="iconStyle" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {newPasswordError && (
                    <Typography variant="body2" className="text-danger">
                      {newPasswordError}
                    </Typography>
                  )}
                </div>
                <div className="edit_profile_password">
                  <TextField
                    fullWidth
                    variant="outlined"
                    type={showConfirmPassword ? 'text' : 'password'}
                    placeholder="Confirm New Password"
                    autoComplete="off"
                    value={confirmPassword}
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                      setConfirmPasswordError('');
                    }}
                    error={confirmPasswordError.length > 0}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() =>
                              setShowConfirmPassword(!showConfirmPassword)
                            }
                            onMouseDown={(e) => e.preventDefault()}
                            edge="end"
                          >
                            {showConfirmPassword ? (
                              <VisibilityOff className="iconStyle" />
                            ) : (
                              <Visibility className="iconStyle" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {confirmPasswordError && (
                    <Typography variant="body2" className="text-danger">
                      {confirmPasswordError}
                    </Typography>
                  )}
                </div>
              </FormGroup>
            </div>
          </div>
        </FormControl>
        <hr />

        <div className="submit-btn d-flex justify-content-end">
          <Button color="primary" onClick={handleSubmitPassword}>
            Save Password
          </Button>
        </div>
      </div>
    </>
  );
};

export default EditProfile;
